
var id = "ask";
var markup = "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"ask\"><path d=\"M512 512m-457.142857 0a457.142857 457.142857 0 1 0 914.285714 0 457.142857 457.142857 0 1 0-914.285714 0Z\" /><path d=\"M625.737143 312.685714c-30.354286-26.697143-70.948571-41.325714-113.737143-41.325714s-83.382857 14.628571-113.737143 41.691429c-31.817143 27.794286-49.371429 65.462857-49.371428 105.325714v7.68c0 4.388571 3.657143 8.045714 8.045714 8.045714h49.005714c4.388571 0 8.045714-3.657143 8.045714-8.045714v-7.68c0-44.982857 43.885714-81.554286 98.011429-81.554286 54.125714 0 98.011429 36.571429 98.011429 81.554286 0 31.817143-22.308571 60.708571-57.051429 74.24-21.577143 8.411429-39.862857 22.674286-53.028571 41.691428-13.531429 19.382857-20.48 42.788571-20.48 66.194286v21.942857c0 4.388571 3.657143 8.045714 8.045714 8.045715h49.005714c4.388571 0 8.045714-3.657143 8.045714-8.045715v-23.04c0-20.114286 12.8-38.4 31.451429-45.714285 60.342857-23.04 99.108571-76.068571 99.108571-135.314286 0-40.228571-17.554286-77.897143-49.371428-105.691429zM512 695.588571c-22.674286 0-40.96 18.285714-40.96 40.96s18.285714 40.96 40.96 40.96c22.674286 0 40.96-18.285714 40.96-40.96s-18.285714-40.96-40.96-40.96z\" fill=\"#ffffff\" /></symbol>";
(function injectSprite() {
  if (typeof document === 'undefined') return;
  var SPRITE_ID = '__UMI_SVG_SPRITE__';
  function ensure() {
    var root = document.getElementById(SPRITE_ID);
    if (!root) {
      root = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      root.setAttribute('id', SPRITE_ID);
      root.setAttribute('aria-hidden', 'true');
      root.setAttribute('style', 'position:absolute;width:0;height:0;overflow:hidden');
      var parent = document.body || document.documentElement;
      parent.insertBefore(root, parent.firstChild);
    }
    if (document.getElementById(id)) return;
    try {
      root.insertAdjacentHTML('beforeend', markup);
      return;
    } catch (e) {}
    try {
      var doc = new DOMParser().parseFromString(
        '<svg xmlns="http://www.w3.org/2000/svg">' + markup + '</svg>',
        'image/svg+xml'
      );
      var node = doc.querySelector('symbol');
      if (node) root.appendChild(document.importNode(node, true));
    } catch (e2) {}
  }
  if (document.body || document.documentElement) ensure();
  else document.addEventListener('DOMContentLoaded', ensure);
})();
module.exports = id;
module.exports.default = id;
module.exports.id = id;
